// import React, { useState, useEffect, useContext } from "react";
// import {
//   Container,
//   CardTitle,
//   FormGroup,
//   Input,
//   Label,
//   Button,
//   CardHeader,
//   Card,
//   Col,
//   Row,
//   Form,
//   TabContent,
//   TabPane,
//   InputGroup,
// } from "reactstrap";

// import UserContext from "../../context/Context";
// import OtpInput from "react-otp-input";
// import logo from "../../img/logo/Rupiologo.png"
// import swal from "sweetalert";
// import axios from "axios";
// import axiosConfig from "../../AxiosConfig";
// import {
//   UserLogin,
//   UserOTPVerify,
//   ViewCompanyDetails,
// } from "../../ApiEndPoint/ApiCalling";
// import { useNavigate } from "react-router-dom";

// export default function Login() {
//   const navigate = useNavigate();
//   const context = useContext(UserContext);

//   const [state, setState] = useState({
//     email: "",
//     password: "",
//     Loader: false,
//     emailotp: "",
//     OtpScreen: false,
//     UserCredential: {},
//     resetpassword: false,
//     type: "password",
//   });

//   const updateState = (data) =>
//     setState((prev) => ({ ...prev, ...data }));

//   // Prevent back
//   useEffect(() => {
//     window.history.pushState(null, null, window.location.href);
//     const handler = () => window.history.go(1);
//     window.addEventListener("popstate", handler);
//     return () => window.removeEventListener("popstate", handler);
//   }, []);

//   const handlechange = (e) => {
//     updateState({ [e.target.name]: e.target.value });
//   };

//   // 🌍 Get Location
//   const getCurrentLocation = () => {
//     return new Promise((resolve, reject) => {
//       navigator.geolocation.getCurrentPosition(
//         (pos) =>
//           resolve({
//             latitude: pos.coords.latitude,
//             longitude: pos.coords.longitude,
//             accuracy: pos.coords.accuracy,
//           }),
//         reject
//       );
//     });
//   };

//   // 🔐 LOGIN
//   const loginHandler = async (e) => {
//     e.preventDefault();
//     updateState({ Loader: true });

//     let latitude = null;
//     let longitude = null;

//     try {
//       const location = await getCurrentLocation();

//       if (location.accuracy > 100) {
//         swal("Weak GPS Signal");
//         updateState({ Loader: false });
//         return;
//       }

//       latitude = location.latitude;
//       longitude = location.longitude;
//     } catch (err) {
//       swal("Location Required");
//       updateState({ Loader: false });
//       return;
//     }

//     try {
//       const res = await UserLogin({
//         email: state.email,
//         password: state.password,
//       });

//       const user = res?.user;

//       if (user?.rolename?.roleName === "MASTER") {
//         updateState({ OtpScreen: true, UserCredential: user });
//         return;
//       }

//       // Save login
//       localStorage.setItem("userData", JSON.stringify(user));
//       localStorage.setItem("loginTime", Date.now());

//       context?.setUserInformatio(user);

//       // Navigate
//       navigate("/");

//       swal("Success", "Logged In!", "success");

//     } catch (err) {
//       updateState({ Loader: false });
//       swal("Login Failed");
//     }
//   };

//   // 🔐 OTP LOGIN
//   const loginOTPHandler = async (e) => {
//     e.preventDefault();

//     if (state.emailotp.length !== 4) {
//       return swal("Enter OTP");
//     }

//     try {
//       const res = await UserOTPVerify({
//         otp: state.emailotp,
//         email: state.UserCredential.email,
//       });

//       if (res?.status) {
//         localStorage.setItem("userData", JSON.stringify(res.user));
//         context?.setUserInformatio(res.user);
//         navigate("/");
//       }
//     } catch {
//       swal("OTP Failed");
//     }
//   };

//   return (
//     <Container>
//       <Row className="m-0 justify-content-center">
//         <Col md="5">
//           <Card className="login-card">
//             <div className="text-center p-2">
//               <img src={logo} alt="logo" height="100" />
//             </div>

//             {state.OtpScreen ? (
//               <>
//                 <CardHeader>
//                   <CardTitle>OTP Login</CardTitle>
//                 </CardHeader>

//                 <Form onSubmit={loginOTPHandler}>
//                   <OtpInput
//                     value={state.emailotp}
//                     onChange={(otp) => updateState({ emailotp: otp })}
//                     numInputs={4}
//                     renderInput={(props) => <input {...props} />}
//                   />

//                   <Button color="primary" type="submit">
//                     Verify OTP
//                   </Button>
//                 </Form>
//               </>
//             ) : (
//               <>
//                 <CardHeader>
//                   <CardTitle>Login</CardTitle>
//                 </CardHeader>

//                 <Form onSubmit={loginHandler}>
//                   <Label>User Name</Label>
//                   <Input
//                     name="email"
//                     value={state.email}
//                     onChange={handlechange}
//                   />

//                   <Label>Password</Label>
//                   <Input
//                     type="password"
//                     name="password"
//                     value={state.password}
//                     onChange={handlechange}
//                   />

//                   <Button color="primary" type="submit">
//                     {state.Loader ? "Loading..." : "Login"}
//                   </Button>
//                 </Form>
//               </>
//             )}
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// }



import React, { useState, useEffect, useContext } from "react";
import {
    Container, CardTitle, Input, Label, Button,
    CardHeader, Card, Col, Row, Form
} from "reactstrap";

import UserContext from "../../context/Context";
import OtpInput from "react-otp-input";
import logo from "../../img/logo/Rupiologo.png";
import swal from "sweetalert";
import axios from "axios";
import {
    UserLogin,
    UserOTPVerify
} from "../../ApiEndPoint/ApiCalling";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../AxiosConfig"
export default function Login({ setIsAuth }) {
    const navigate = useNavigate();
    const context = useContext(UserContext);

    const [state, setState] = useState({
        email: "",
        password: "",
        Loader: false,
        emailotp: "",
        OtpScreen: false,
        UserCredential: {},
        resetpassword: false
    });

    const updateState = (data) =>
        setState((prev) => ({ ...prev, ...data }));

    // 🔥 GET USER IP
    const getUserIP = async () => {
        try {
            const res = await axios.get("https://api.ipify.org?format=json");
            return res.data.ip;
        } catch {
            return "UNKNOWN_IP";
        }
    };

    // 🌍 GET LOCATION
    const getCurrentLocation = () => {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (pos) =>
                    resolve({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        accuracy: pos.coords.accuracy,
                    }),
                reject
            );
        });
    };

    // 🔐 LOGIN
//     const loginHandler = async (e) => {
//         e.preventDefault();
//         updateState({ Loader: true });

//         let latitude = "";
//         let longitude = "";
//         let publicIP = "";

//         try {
//             const location = await getCurrentLocation();

//             if (location.accuracy < 100) {
//                 swal("Weak GPS Signal");
//                 updateState({ Loader: false });
//                 return;
//             }

//             latitude = location.latitude;
//             longitude = location.longitude;

//         } catch {
//             swal("Location Required");
//             updateState({ Loader: false });
//             return;
//         }

//         try {
//             publicIP = await getUserIP(); // ✅ IP fetch
//         } catch { }

//         try {
//             const res = await UserLogin({
//                 email: state.email,
//                 password: state.password,
//             });

//             const user = res?.user;
//              if (!res?.status || !user) {
//       throw new Error("Login failed");
//     }
//             // OTP case
//             if (user?.rolename?.roleName === "MASTER") {
//                 updateState({ OtpScreen: true, UserCredential: user, Loader: false });
//                 return;
//             }

//             // ✅ SAVE DATA
//             localStorage.setItem("userData", JSON.stringify(user));
//             localStorage.setItem("loginTime", Date.now());

//             // 👉 extra info save
//             localStorage.setItem("loginMeta", JSON.stringify({
//                 ip: publicIP,
//                 latitude,
//                 longitude
//             }));

//             context?.setUserInformatio(user);

//     swal("Success", res.message || "Logged In!", "success");
// setIsAuth(true);
//             navigate("/");

//         } catch (err) {
//             updateState({ Loader: false });
//             swal("Login Failed");
//         }
//     };
const loginHandler = async (e) => {
  e.preventDefault();
   if (!navigator.onLine) {
    swal(
      "No Internet Connection",
      "Please connect to the internet and try again.",
      "error"
    );
    return;
  }
  updateState({ Loader: true });

  let latitude = "";
  let longitude = "";
  let publicIP = "";

  try {
    const location = await getCurrentLocation();

    if (location.accuracy < 100) {
      swal("Weak GPS Signal");
      updateState({ Loader: false });
      return;
    }

    latitude = location.latitude;
    longitude = location.longitude;

  } catch {
    swal("Location Required");
    updateState({ Loader: false });
    return;
  }

  try {
    publicIP = await getUserIP();
  } catch {}

  try {
    const res = await UserLogin({
      email: state.email,
      password: state.password,
    });

    const user = res?.user;

    if (!res?.status || !user) {
      throw new Error("Login failed");
    }

    // OTP case
    if (user?.rolename?.roleName === "MASTER") {
      updateState({ OtpScreen: true, UserCredential: user, Loader: false });
      return;
    }

    // ✅ SAVE USER
    localStorage.setItem("userData", JSON.stringify(user));
    localStorage.setItem("loginTime", Date.now());

    localStorage.setItem("loginMeta", JSON.stringify({
      ip: publicIP,
      latitude,
      longitude
    }));

    // 🔥 👉 LOGIN ACTIVITY LOG (SESSION ID PART)
    try {
      const now = new Date();

      const date = `${String(now.getMonth() + 1).padStart(2, "0")}/${String(
        now.getDate()
      ).padStart(2, "0")}/${now.getFullYear()}`;

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      const logInTime = `${hours}:${minutes}:${seconds} ${ampm}`;

      const payload = {
        publicIP,
        name: user?.firstName,
        date,
        logInTime,
        roleName: user?.rolename?.roleName,
        userId: user?._id,
        database: user?.database,
        latitude: latitude?.toString(),
        longitude: longitude?.toString(),
      };

      const response = await axiosConfig.post("/activity/save-log", payload);

      console.log("Login log saved ✅", response.data);

      // 🔥 SAVE SESSION ID
      if (response?.data?.sessionId) {
        localStorage.setItem("sessionId", response.data.sessionId);
      }

      // optional
      localStorage.setItem("loginInfo", JSON.stringify(payload));

    } catch (err) {
      console.log("Login log error:", err?.response?.data || err.message);
    }

    context?.setUserInformatio(user);

    setIsAuth(true);

    swal("Success", res.message || "Logged In!", "success");

    navigate("/", { replace: true });

  } catch (err) {
    console.error("LOGIN ERROR:", err);
    swal("Login Failed");
  } finally {
    updateState({ Loader: false });
  }
};
    // 🔐 OTP LOGIN
    const loginOTPHandler = async (e) => {
        e.preventDefault();

        if (state.emailotp.length !== 4) {
            return swal("Enter OTP");
        }

        try {
            const res = await UserOTPVerify({
                otp: state.emailotp,
                email: state.UserCredential.email,
            });
            if (res?.status) {
                localStorage.setItem("userData", JSON.stringify(res.user));
                context?.setUserInformatio(res.user);
                navigate("/users");
            }
        } catch {
            swal("OTP Failed");
        }
    };
    const handleForgetPassword = async (e) => {
  e.preventDefault();

  try {
    const formdata = new FormData();

    formdata.append("email", state.email);
    formdata.append("base_url", state.password); // ✅ correct (no quotes)

    const res = await axiosConfig.post(
      "/forgetPasswordEmailVerify",
      formdata
    );

    console.log(res);

    swal("Email has been sent to Your Mail id", "Please Check and verify");

    updateState({ resetpassword: false });

  } catch (err) {
    console.log(err);
    swal("Error", "Something went wrong", "error");
  }
};
    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#f5f5f5",
            }}
        >
            <Container>
                <Row className="justify-content-center">
                    <Col md="5">
                        <Card style={{ padding: "20px", borderRadius: "10px" }}>

                            {/* LOGO */}
                            <div className="text-center mb-3">
                                <img src={logo} alt="logo" height="80" />
                            </div>

                            {state.resetpassword ? (
                                // 🔐 FORGET PASSWORD SCREEN
                                <>
                                    <CardHeader className="text-center"
                                        style={{ background: "transparent", borderBottom: "none" }}>
                                        <CardTitle tag="h3">Reset Password</CardTitle>
                                        <p style={{ fontSize: "13px", color: "#999" }}>
                                            Enter your email to reset password
                                        </p>
                                    </CardHeader>

                                    <Form onSubmit={handleForgetPassword}>
                                        <Label>Email</Label>
                                        <Input
                                            name="email"
                                            value={state.email}
                                            onChange={(e) => updateState({ email: e.target.value })}
                                            style={{ marginBottom: "15px" }}
                                        />

                                        <Button color="primary" block>
                                            Submit
                                        </Button>

                                        {/* 🔙 Back */}
                                        <div style={{ textAlign: "center", marginTop: "10px" }}>
                                            <Button
                                                color="link"
                                                onClick={() => updateState({ resetpassword: false })}
                                            >
                                                Back to Login
                                            </Button>
                                        </div>
                                    </Form>
                                </>
                            ) : state.OtpScreen ? (
                                // 🔐 OTP SCREEN
                                <>
                                    <CardHeader
                                        className="text-center"
                                        style={{ background: "transparent", borderBottom: "none" }}
                                    >
                                        <CardTitle tag="h3">OTP Login</CardTitle>
                                        <p style={{ fontSize: "13px", color: "#999" }}>
                                            Welcome Back, Please Login to Your Account.
                                        </p>
                                    </CardHeader>

                                    <Form onSubmit={loginOTPHandler}>
                                        <div className="d-flex justify-content-center mb-3">
                                            <OtpInput
                                                value={state.emailotp}
                                                onChange={(otp) => updateState({ emailotp: otp })}
                                                numInputs={4}
                                                containerStyle={{
                                                    display: "flex",
                                                    gap: "15px", // 🔥 gap between boxes
                                                }}
                                                renderInput={(props) => (
                                                    <input
                                                        {...props}
                                                        style={{
                                                            width: "55px",
                                                            height: "55px",
                                                            fontSize: "20px",
                                                            borderRadius: "10px",
                                                            border: "1px solid #ccc",
                                                            textAlign: "center",
                                                            outline: "none",
                                                        }}
                                                        onFocus={(e) => (e.target.style.border = "2px solid #0d6efd")}
                                                        onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                                                    />
                                                )}
                                            />
                                        </div>

                                        <Button color="primary" block>
                                            Verify OTP
                                        </Button>
                                    </Form>
                                </>
                            ) : (
                                // 🔐 NORMAL LOGIN
                                <>
                                    <CardHeader
                                        className="text-center"
                                        style={{ background: "transparent", borderBottom: "none" }}
                                    >
                                        <CardTitle tag="h3">Login</CardTitle>
                                        <p style={{ fontSize: "13px", color: "#999" }}>
                                            Welcome Back, Please Login to Your Account.
                                        </p>
                                    </CardHeader>

                                    <Form onSubmit={loginHandler}>
                                        <Label>User Name</Label>
                                        <Input
                                            name="email"
                                            value={state.email}
                                            onChange={(e) => updateState({ email: e.target.value })}
                                            style={{ marginBottom: "15px" }}
                                        />

                                        <Label>Password</Label>
                                        <Input
                                            type="password"
                                            name="password"
                                            value={state.password}
                                            onChange={(e) => updateState({ password: e.target.value })}
                                        />

                                        {/* 🔥 FIX HERE */}
                                        <div style={{ textAlign: "right", marginTop: "8px" }}>
                                            <Button
                                                color="link"
                                                style={{ padding: 0 }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    updateState({ resetpassword: true }); // ✅ SWITCH SCREEN
                                                }}
                                            >
                                                Forgot Password?
                                            </Button>
                                        </div>

                                        <Button
                                            color="primary"
                                            block
                                            style={{ marginTop: "20px" }}
                                        >
                                            {state.Loader ? "Loading..." : "Login"}
                                        </Button>
                                    </Form>
                                </>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}